
import { Component, Vue, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import { UserModule } from '../../store/modules/user'

@Component({
  name: 'package',
  filters: {
    formatDate: function(value, type) {
      if (!value) {
        return
      }
      let date = new Date(value * 1000)
      let y = date.getFullYear()
      let MM: any = date.getMonth() + 1
      MM = MM < 10 ? ('0' + MM) : MM
      let d: any = date.getDate()
      d = d < 10 ? ('0' + d) : d
      let h: any = date.getHours()
      let next_h: any = h < 10 ? ('0' + (h + 1)) : (h + 1)
      h = h < 10 ? ('0' + h) : h
      let m: any = date.getMinutes()
      m = m < 10 ? ('0' + m) : m
      let s: any = date.getSeconds()
      s = s < 10 ? ('0' + s) : s
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m
    }
  },
  components: {}
})


export default class extends Vue {
  org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
  list: any = []

  essential_name: string = ''  // 要点名称
  essential_user: string = ''  // 创建人
  userList: any = []
  tableData:any = []
  size: number = 1
  dialog: boolean = false
  is_add: boolean = true
  info: any = {
    pid: '',
    name: '',
    level: 2,
    content: '',
    is_enabled: 0,
    material: [],
    instrument: '',
    employee_id: '',
    class_hours: 0
  }
  employeeList: any = []
  materialList: any = []
  instrumentType: any = []
  instrument: string = ''
  itemVal: any = {}
  total: number = 0
  loading: boolean = true

  @Watch('info.instrument')
  getMaterialList(newVal, oldVal) {
    this.getMaterial()
  }
  handleCurrentChange(val) {
    this.size = val
    this.getList()
  }

  //  历史搜索
  async selectHistory() {
    const page_name: string = '3'
    const res: any = await CourseModule.selectHistory({page_name: page_name})
    this.essential_name = res.data.name
    this.essential_user = res.data.employee_id
    this.instrument = res.data.instrument_type_id
    this.getList()
  }
  //  乐器类型筛选
  async getInstrumentType(){ //乐器类型
    const res: any = await UserModule.InstrumentType()
    if(res.code === 200) {
      this.instrumentType = res.data.list
    }
  }
  changePopInstrument(val) {
    this.info.instrument = val
  }
  changeInstrumentType(val) {
    this.instrument = val
    this.getList()
  }

  async getList() {
    let data = {
      employee_id: this.essential_user,
      name: this.essential_name,
      instrument_type_id: this.instrument,
      page: this.size,
      size: 10
    }
    const res: any = await CourseModule.essentialList(data)
    if (res.code === 200) {
      this.tableData = res.data.list
      this.total = res.data.total
      this.loading = false
    }
  }
  //  新建 && 编辑
  async newEssential(data) {
    const res: any = await CourseModule.newEssential(data)
    if(res.code === 200) {
      this.$message({
        type: 'success',
        message: '操作成功!'
      })
      this.getList()
      this.dialogClose()
     
    } else {
      this.$message.error('操作失败！')
    }
  }
  //  修改挺启用状态
  changeHandle(row) {
     let text = ''
      if (row.is_enabled === 0) {
        text = '启用'
      } else {
        text = '禁用'
      }
      this.$confirm(`是否变更状态为${text}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async ()=> {
        let data = {
          id: row.id,
          is_enabled: row.is_enabled === 0 ? 1 : 0
        }
        this.newEssential(data)
        
      }).catch(() => {})
  }

  //  素材列表
  async getMaterial() {
    const res: any = await CourseModule.getEssentialMaterial({org_id: '', teacherEmployeeId: '', student_id: '', instrument_type_id: this.info.instrument})
    if(res.code === 200) {
      this.materialList = res.data.list
    }
  }
  //  父级要点list
  async getessential(){
    const res: any = await CourseModule.alertEssential({level: 1})
    if(res.code === 200) {
      this.employeeList = res.data
    }
  }
  changeEssential(val) {
    this.getList()
  }
  onAdd() {
    this.getessential()
    this.itemVal.level = 2
    this.dialog = true
    this.is_add = true
  }
  onEdit(val){
    this.getessential()

    this.itemVal = val
    if(val.level === 1) {
      this.info.pid = ''
    } else {
      this.info.pid = val.pid
    }
    this.info.level = val.level
    this.info.name = val.name
    this.info.content = val.content
    this.info.class_hours = val.class_hours
    this.info.is_enabled = val.is_enabled
    this.info.material = val.essential_material_id
    this.info.employee_id = val.employee_id
    this.info.instrument = val.instrument_type_id
    this.dialog = true
    this.is_add = false
  }
  dialogClose() {
    this.dialog = false
    this.info.pid = ''
    this.info.name = ''
    this.info.level = 2
    this.info.content = ''
    this.info.is_enabled = 0
    this.info.material = []
    this.info.employee_id = ''
    this.info.instrument = ''
    this.info.class_hours = 0
  }
  dialogTrue() {
    if(this.info.pid) {
      this.info.level = 2
    } else {
      this.info.level = 1
    }

    let data = {
      pid: this.info.pid,
      name: this.info.name,
      level: this.info.level,
      content: this.info.content,
      is_enabled: this.info.is_enabled,
      material: this.info.material,
      employee_id: this.info.employee_id,
      instrument_type_id: this.info.instrument,
      class_hours: this.info.class_hours
    }
    if(this.is_add) {
      this.newEssential(data)
    } else {
      data['id'] = this.itemVal.id
      this.newEssential(data)
    }
  }

  async getAllTeacher() {
     const res: any = await CourseModule.getAllTeacher({ is_all: 1 })
     if(res.code === 200) {
       this.userList = res.data.list
       this.selectHistory()
     }
  }
  mounted() {
    this.getInstrumentType()
    this.getAllTeacher()
  }
}
